import React from 'react'
import context from '@/context'
import { TabContent, TabNavItems, TabPane } from '@/components/tabs'
import { DataLoader } from '@/components/dataLoader'
import { BackgroundJobRow } from '@/components/backgroundJobs/backgroundJobMenuItem'
import getComponentKey from '@/utils/getComponentKey'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'
import { localized } from '@/decorators/localized'
import { WhiteBox } from '@/components/Layout'

@localized()
class ReportSubmissionsTabs extends React.Component {
  state = {
    tab: 'details',
    backgroundJobsKey: getComponentKey()
  }
  renderRelatedJobs = ({ data, loading }) => {
    if (loading) { return (<LoadingIndicator />) }
    if (data.length === 0) { return <div>{this.props.localize('Common.NoRelatedBackgroundJob')}</div> }
    const jobs = data.map(j => ({ ...j, data: j.data ? JSON.parse(j.data) : j.data }))
    return jobs.map((job, idx) => <BackgroundJobRow key={job.id} {...job} showAllInfo isRelatedJobs />)
  }
  render () {
    const { localize, parentId } = this.props
    return (
      <React.Fragment>
        <TabNavItems
          buttonView
          activeTabId={this.state.tab}
          onClick={tab => this.setState({ tab })}
          items={[
            { id: 'details', text: 'Common.Details' },
            { id: 'related', text: 'Common.Related' }
          ]} />
        <TabContent activeTab={this.state.tab} renderActiveOnly>
          <TabPane tabId='details'>{this.props.children}</TabPane>
          <TabPane tabId='related'>
            <div className='background-jobs'>
              <WhiteBox
                header='Reporting.RelatedBackgroundJobs'
                buttons={<Button color='primary' onClick={() => this.setState({ backgroundJobsKey: getComponentKey() })}>{localize('Common.Refresh')}</Button>}
              >
                <DataLoader
                  key={this.state.backgroundJobsKey}
                  dataSource={(options) => context.api.backgroundJobService.getBackgroundJobsRelatedToReportSubmissionGroup(parentId, options)}
                  render={this.renderRelatedJobs} />
              </WhiteBox>
            </div>
          </TabPane>
        </TabContent>
      </React.Fragment>
    )
  }
}

export {
  ReportSubmissionsTabs
}



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/reportSubmissionsTabs.js